export class PostPriorReportRequest {
    constructor(data: { file: File; priorAccessionNumber: string; priorModality: string; priorStudyDate: string }) {
        this.file = data.file;
        this.priorAccessionNumber = data.priorAccessionNumber;
        this.priorModality = data.priorModality;
        this.priorStudyDate = data.priorStudyDate;
    }

    private readonly file: File;
    private readonly priorAccessionNumber: string;
    private readonly priorModality: string;
    private readonly priorStudyDate: string;

    get formData(): FormData {
        const formData = new FormData();
        formData.append('File', this.file);
        formData.append('PriorAccessionNumber', this.priorAccessionNumber);
        formData.append('PriorModality', this.priorModality);
        formData.append('PriorStudyDate', this.priorStudyDate);
        return formData;
    }
}
